import { Children, type ReactNode } from 'react';
import { Button, Drawer, Empty, Popover, Statistic, Table } from 'antd';
import type { TableProps, ThemeConfig } from 'antd';

export const consoleTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2859b8', colorText: '#202b3c', colorTextSecondary: '#66758a',
    colorBorder: '#dce2ea', colorBgLayout: '#f2f4f7', borderRadius: 5,
    fontFamily: '"Segoe UI", "Microsoft YaHei", system-ui, sans-serif',
    fontSize: 14, controlHeight: 32,
  },
  components: {
    Layout: { headerHeight: 54, headerBg: '#ffffff', siderBg: '#ffffff' },
    Card: { headerHeight: 44, bodyPadding: 16, headerFontSize: 14 },
    Table: { cellPaddingBlockSM: 9, cellPaddingInlineSM: 12, headerBg: '#f6f8fa', headerColor: '#516075', borderColor: '#e8ecf1' },
    Menu: { itemHeight: 36, itemMarginBlock: 2, itemBorderRadius: 5, itemSelectedBg: '#eaf0fc', itemSelectedColor: '#234f9c' },
    Tabs: { horizontalMargin: '0 0 14px 0', titleFontSize: 14 },
    Statistic: { contentFontSize: 25, titleFontSize: 13 },
  },
};

export function PageToolbar({ children, actions }: { children?: ReactNode; actions?: ReactNode }) {
  return <div className="page-toolbar"><div className="toolbar-context">{children}</div><div className="toolbar-actions">{actions}</div></div>;
}

export type Metric = { label: string; value: number; suffix?: ReactNode; precision?: number; tone?: 'warning' | 'danger' | 'success' };
export function MetricStrip({ items }: { items: Metric[] }) {
  return <div className="metric-strip">{items.map(item => <div key={item.label} className={`metric-cell ${item.tone ? `metric-${item.tone}` : ''}`}>
    <Statistic title={item.label} value={item.value} suffix={item.suffix} precision={item.precision} />
  </div>)}</div>;
}

/** Keep the existing form mounted: closing a drawer must not discard a draft. */
export function OperationDrawer({ open, onClose, title, extra, children }: {
  open: boolean; onClose: () => void; title?: ReactNode; extra?: ReactNode; children?: ReactNode;
}) {
  return <Drawer open={open} onClose={onClose} title={title} size="min(640px, 100vw)" forceRender className="operation-drawer">
    {extra && <div className="drawer-context">{extra}</div>}{children}
  </Drawer>;
}

/** Original buttons and their confirmations remain intact inside the action panel. */
export function ActionMenu({ children }: { children: ReactNode }) {
  if (!Children.toArray(children).length) return <span className="muted">无可用操作</span>;
  return <Popover trigger="click" placement="bottomRight" content={<div className="action-menu" role="group" aria-label="可用操作">{children}</div>}>
    <Button size="small" aria-label="展开处理操作">处理 <span aria-hidden>▾</span></Button>
  </Popover>;
}

export function DenseTable<T extends object>(props: TableProps<T>) {
  return <div className="dense-table"><Table<T> size="small" {...props}
    locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据" />, ...props.locale }} />
  </div>;
}
